import { useCallback, useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { prettySubPathUrl } from "../../../../helpers";
import { GET_PROD_OR_DEV } from "../../../../constants/api";
import * as r from "../../../../constants/routes";
import UserTrainingContext from "../../../../context/userTrainingContext";

export function useGameList({ active_category, setGameUrl, game_list }: any) {
  const history = useNavigate();

  const tContext = useContext(UserTrainingContext);
  const { setActiveCategory } = tContext;

  const location = useLocation();

  // Pega a categoria da URL
  const categorySlug = location.pathname.split("/")[2];

  // Converte o slug para o formato usado nas habilidades (ex.: agilidade mental)
  const categoryName = categorySlug?.replace(/-/g, " ");

  // Usa a categoria do contexto ou, enquanto ela não atualiza, a categoria da URL
  const activeCategoryAux = useMemo(() => {
    return active_category ?? categoryName;
  }, [active_category, categoryName]);

  const normalize = (text?: string) =>
    text
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  // Ordena jogos pt_br para ficarem primeiro na lista
  const orderPtBrFirst = (games: any[]) => {
    return [...games].sort((a: any, b: any) => {
      if (a.language === "pt_br") return -1;
      if (b.language === "pt_br") return 1;
      return 0;
    });
  };

  // Filtra os jogos da categoria
  const filteredGameList = useMemo(() => {
    const filtered = game_list?.filter((game: any) =>
      game.abilities.some(
        (ability: any) => normalize(ability) === normalize(activeCategoryAux),
      ),
    );

    return filtered ? orderPtBrFirst(filtered) : [];
  }, [game_list, activeCategoryAux]);

  // Mantém a categoria do contexto sincronizada com a URL
  useEffect(() => {
    if (!categoryName) return;

    if (active_category !== categoryName) {
      setActiveCategory(categoryName);
    }
  }, [categoryName, active_category, setActiveCategory]);

  // Escolhe um jogo aleatório apenas pt_br
  const randomGame = useMemo(() => {
    if (!filteredGameList?.length) return null;

    const filterGamePtBr = filteredGameList.filter(
      (game) => game.language === "pt_br",
    );

    const index = Math.floor(Math.random() * filterGamePtBr.length);

    return filterGamePtBr[index];
  }, [filteredGameList]);

  // Navega para o jogo e define sua URL
  const handleGameClick = useCallback(
    (game: any) => {
      history(
        prettySubPathUrl(
          r.GET_R_U_TRAIN_GAME_SCREEN(activeCategoryAux, game.name),
        ),
      );
      setGameUrl(game.activity_urls[GET_PROD_OR_DEV], game.name);
    },
    [history, activeCategoryAux, setGameUrl],
  );

  return {
    activeCategoryAux,
    filteredGameList,
    randomGame,
    handleGameClick,
    normalize,
  };
}
